
var auth2; // The Sign-In object.
var googleUser; // The current user.

/**
 * Initializes the Sign-In client.
 */
var initClient = function(CLIENT_ID) {
	try{
		gapi.load('auth2', function(){
	        /**
	         * Retrieve the singleton for the GoogleAuth library and set up the
	         * client.
	         */
	        auth2 = gapi.auth2.init({
	            client_id: CLIENT_ID + '.apps.googleusercontent.com',
	            scope: 'profile'
	        });
	        
	        auth2.attachClickHandler('customBtn', {}, onSuccess, onFailure);
	        
	        auth2.attachClickHandler('customBtnRegister', {}, onSuccess, onFailure);
	
	        // Listen for sign-in state changes.
	        auth2.isSignedIn.listen(signinChanged);
	        
	        // Listen for changes to current user.
	        auth2.currentUser.listen(userChanged);
	
	        // Sign in the user if they are currently signed in.
//	        if (auth2.isSignedIn.get() == true) {
//	          	auth2.signIn();
//	        }
	
	        // Start with the current live values.
	        refreshValues();
	
	    });
	} catch(e){
		console.log(e);
	};
};

/**
 * Handle successful sign-ins.
 */
var onSuccess = function(user) {
    console.log('Signed in as ' + JSON.stringify(auth2.currentUser.get(), undefined, 2));
    window.parent.loginSocialNetworkUser(user.getAuthResponse().id_token,"google",user.getBasicProfile().getEmail(),null,null,0,null,null);
    
};

/**
 * Handle sign-in failures.
 */
var onFailure = function(error) {
    console.log(error);
};

/**
 * Listener method for sign-out live value.
 *
 * @param {boolean} val the updated signed out state.
 */
var signinChanged = function (val) {
  console.log('Signin state changed to ', val);
};

/**
* Listener method for when the user changes.
*
* @param {GoogleUser} user the updated user.
*/
var userChanged = function (user) {
 updateGoogleUser(user);
};

/**
 * Updates the properties in the Google User table using the current user.
 */
var updateGoogleUser = function (user) {
  googleUser = user;
  if (googleUser) {
	 console.log('user-id:' + googleUser.getId());
  } else {
	 console.log('user-id:--');
  }
};

/**
 * Retrieves the current user and signed in states from the GoogleAuth
 * object.
 */
var refreshValues = function() {
  if (auth2){
    console.log('Refreshing values...');

    console.log('isSignedIn:' + auth2.isSignedIn.get());
    updateGoogleUser(auth2.currentUser.get());
  }
}

var signOut = function() {
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(function () {
      console.log('User signed out.');
    });
    auth2.disconnect();

}



